import { Children, FC, ReactElement, ReactNode } from "react";

interface Props {
    name: string;
    content: ReactNode;
}

const Slot: FC<Props> = ({ name, content }) => {
    let match;

    Children.forEach(content, (child) => {
        const _child = child as ReactElement;
        if (_child?.props.name === name) {
            match = _child.props.children;
        }
    });

    return match ?? null;
};

export { Slot };
